var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.dialog.isActive)?_c('main-dialog'):_vm._e(),_c('main-header'),_c('main-nav'),_c('v-main',[_c('app-alert',{on:{"dismissed":_vm.onDismissed}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }